// Kept in sync with the backend's published posts by scripts/syncBlogRoutes.js
// (runs automatically before every build) — don't hand-edit blog entries here.
import BLOG_ROUTES from '../data/blogRoutes.generated.json';

export const PRERENDER_ROUTES = [
  '/',
  '/fr',
  '/de',
  '/404',
  ...BLOG_ROUTES,
  '/auth/login',
  '/auth/signup',
  '/auth/verify',
  '/contact-us',
  '/pricing',
  '/privacy_policy',
  '/subscription/success',
  '/terms_and_conditions',
  '/de/exam-tips',
  '/de/exam-tips/ask-reformulate',
  '/de/fide-exam-overview',
  '/de/mock-exams',
  '/de/mock-exams/listening',
  '/de/fide-flashcards',
  '/de/fide-test-b1-discussion',
  '/de/fide-vocabulary',
  '/de/fide-test-topics',
  '/de/fide-practice',
  '/de/fide-practice/topics/all/vocab',
  '/de/fide-practice/topics/all/flashcards',
  '/de/fide-practice/a1/dialogue',
  '/de/fide-practice/a2/intro',
  '/de/fide-practice/a2/image',
  '/de/fide-practice/a2/telephone-roleplay',
  '/de/fide-practice/a2/discussion',
  '/de/fide-practice/b1/discussion',
  '/de/fide-practice/a2/telephone/video/1',
  '/de/fide-practice/a2/telephone/video/2',
  '/de/fide-practice/a2/telephone/video/3',
  '/de/fide-practice/a2/telephone/video/4',
  '/de/fide-practice/a2/telephone/video/5',
  '/de/fide-practice/a2/telephone/video/19',
  '/de/fide-practice/a2/telephone/video/20',
  '/de/fide-practice/a2/telephone/video/21',
  '/de/fide-practice/a2/telephone/video/22',
  '/de/fide-practice/a2/telephone/video/23',
  '/de/fide-practice/a2/telephone/video/68',
  '/de/fide-practice/a2/telephone/video/69',
  '/de/fide-practice/a2/telephone/video/70',
  '/de/fide-practice/a2/telephone/video/71',
  '/de/fide-practice/a2/telephone/video/72',
  '/de/fide-practice/b1/discussion/topics',
  '/fr/exam-tips',
  '/fr/exam-tips/ask-reformulate',
  '/fr/fide-exam-overview',
  '/fr/mock-exams',
  '/fr/mock-exams/listening',
  '/fr/fide-flashcards',
  '/fr/fide-test-b1-discussion',
  '/fr/fide-test-example-videos',
  '/fr/fide-test-example-videos/-Q0ouh-hamg',
  '/fr/fide-test-example-videos/7GmH9IfrH94',
  '/fr/fide-test-example-videos/AQhRac-pkaE',
  '/fr/fide-test-example-videos/F5UN6prJlOE',
  '/fr/fide-test-example-videos/FNYBkonN42k',
  '/fr/fide-test-example-videos/gkCPCwndmt4',
  '/fr/fide-test-example-videos/iwFt5OdW5pE',
  '/fr/fide-test-example-videos/Iy6AF_hp648',
  '/fr/fide-test-example-videos/L80b5gpxDBA',
  '/fr/fide-test-example-videos/ppto4E3QhRc',
  '/fr/fide-test-example-videos/RhyeZjnkWOI',
  '/fr/fide-test-example-videos/vsE1mKH8lMo',
  '/fr/fide-test-example-videos/ZJ18O8_KMUI',
  '/fr/fide-test-example-videos/_mEtMgtDFWw',
  '/fr/fide-vocabulary',
  '/fr/fide-test-topics',
  '/fr/fide-practice',
  '/fr/fide-practice/topics/all/vocab',
  '/fr/fide-practice/topics/all/flashcards',
  '/fr/fide-practice/a1/dialogue',
  '/fr/fide-practice/a2/intro',
  '/fr/fide-practice/a2/image',
  '/fr/fide-practice/a2/telephone-roleplay',
  '/fr/fide-practice/a2/discussion',
  '/fr/fide-practice/b1/discussion',
  '/fr/fide-practice/a2/telephone/video/1',
  '/fr/fide-practice/a2/telephone/video/2',
  '/fr/fide-practice/a2/telephone/video/3',
  '/fr/fide-practice/a2/telephone/video/4',
  '/fr/fide-practice/a2/telephone/video/5',
  '/fr/fide-practice/a2/telephone/video/19',
  '/fr/fide-practice/a2/telephone/video/20',
  '/fr/fide-practice/a2/telephone/video/21',
  '/fr/fide-practice/a2/telephone/video/22',
  '/fr/fide-practice/a2/telephone/video/23',
  '/fr/fide-practice/a2/telephone/video/68',
  '/fr/fide-practice/a2/telephone/video/69',
  '/fr/fide-practice/a2/telephone/video/70',
  '/fr/fide-practice/a2/telephone/video/71',
  '/fr/fide-practice/a2/telephone/video/72',
  '/fr/fide-practice/b1/discussion/topics',
];

const prerenderRouteSet = new Set(PRERENDER_ROUTES);

export const normalizePrerenderPathname = (pathname = '') => {
  if (typeof pathname !== 'string' || pathname.length === 0) {
    return '/';
  }

  const withoutQuery = pathname.split('?')[0].split('#')[0] || '/';
  if (withoutQuery === '/') {
    return '/';
  }

  return withoutQuery.endsWith('/') ? withoutQuery.slice(0, -1) : withoutQuery;
};

export const isPrerenderedPathname = (pathname = '') => prerenderRouteSet.has(normalizePrerenderPathname(pathname));
